var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SwitchOption',{staticClass:"alert-switch",attrs:{"optionColor":"#929292","optionFontSize":"12px","option-name":_vm.switchTitle,"switch-model":_vm.localValue},on:{"update:switchModel":function($event){_vm.localValue=$event},"update:switch-model":function($event){_vm.localValue=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }